import Vuex from 'vuex';

import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';

export default function createStore({
  amounts,
  amountsUrl,
  cancelMessage,
  countries,
  discountCode,
  formUrl,
  inputs,
  merchantContactInfo,
  noFocus,
  orderBump,
  orderQuantity,
  showOrderQuantity,
  paymentTypes,
  product,
  productRecurrence,
  psps,
  required,
  optional,
  selectedPaymentType,
  selectedPspCode,
  testimonials
}) {
  const store = new Vuex.Store({
    state: {
      amounts,
      amountsUrl,
      cancelMessage,
      countries,
      discountCode,
      formUrl,
      inputs,
      merchantContactInfo,
      noFocus,
      orderBump,
      orderQuantity,
      showOrderQuantity,
      paymentTypes,
      product,
      productRecurrence,
      psps,
      required,
      optional,
      selectedPaymentType,
      selectedPspCode,
      testimonials,
      validDiscountCode: product.discounted
    },
    actions,
    mutations,
    getters
  });

  return store;
}
